var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',{staticClass:"nav-links"}),_c('div',{staticClass:"nav-contact"},[_c('div',{staticClass:"nav-item email"},[_c('a',{attrs:{"href":"mailto:eugene@builtbyeugene.com"}},[_vm._v("eugene@builtbyeugene.com")])])])])
}]

export { render, staticRenderFns }